export default function HandShake({ className }) {
  return (
    <div>
      <svg
        width='99'
        height='94'
        viewBox='0 0 99 94'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
      >
        <path
          d='M45.0398 66.1956L53.2288 73.976C54.0354 74.7423 54.9929 75.3502 56.0467 75.7649C57.1005 76.1796 58.2299 76.3931 59.3706 76.3931C60.5112 76.3931 61.6406 76.1796 62.6944 75.7649C63.7482 75.3502 64.7057 74.7423 65.5123 73.976C66.3188 73.2097 66.9586 72.3 67.3951 71.2987C67.8316 70.2975 68.0563 69.2244 68.0563 68.1407C68.0563 67.057 67.8316 65.9838 67.3951 64.9826C66.9586 63.9814 66.3188 63.0717 65.5123 62.3053M57.3233 54.5249L67.5595 64.2505C69.1884 65.7981 71.3977 66.6675 73.7013 66.6675C76.0049 66.6675 78.2141 65.7981 79.843 64.2505C81.4719 62.7028 82.387 60.6038 82.387 58.4151C82.387 56.2264 81.4719 54.1274 79.843 52.5798L63.9564 37.4857C61.6532 35.3002 58.5312 34.0726 55.2761 34.0726C52.0209 34.0726 48.8989 35.3002 46.5958 37.4857L42.9926 40.9091C41.3637 42.4567 39.1545 43.3262 36.8509 43.3262C34.5473 43.3262 32.338 42.4567 30.7091 40.9091C29.0802 39.3615 28.1651 37.2625 28.1651 35.0738C28.1651 32.8851 29.0802 30.7861 30.7091 29.2384L42.2147 18.3069C45.9498 14.7674 50.8208 12.5126 56.0566 11.8996C61.2925 11.2866 66.5939 12.3503 71.1217 14.9224L73.0461 16.0117C74.7895 17.0114 76.8624 17.3581 78.8603 16.9842L85.9847 15.6227M85.9847 11.7324L90.0792 54.5249H81.8902M12.2839 11.7324L8.18945 54.5249L34.8036 79.8114C36.4325 81.359 38.6418 82.2284 40.9454 82.2284C43.249 82.2284 45.4582 81.359 47.0871 79.8114C48.716 78.2637 49.6311 76.1647 49.6311 73.976C49.6311 71.7873 48.716 69.6883 47.0871 68.1407M12.2839 15.6227H45.0398'
          stroke='#3A3A3A'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </div>
  );
}
